import { render, staticRenderFns } from "./Hotwires.vue?vue&type=template&id=2029557d&scoped=true"
import script from "./Hotwires.vue?vue&type=script&lang=js"
export * from "./Hotwires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029557d",
  null
  
)

export default component.exports